// Dynamic styles based on theme - to be used with useThemedStyles.
export const createMarketSetupDetailStyles = ({ ui: { colors, type, space, radius } }) => ({
	scrollView: {
		flex: 1,
		backgroundColor: colors.canvas,
	},
	content: {
		paddingHorizontal: space.gutter,
		paddingTop: 20,
		paddingBottom: space.xl,
		gap: space.lg,
	},
	loaderContainer: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
	},
	fieldLabel: {
		...type.fieldLabel,
		color: colors.text,
		marginTop: space.md,
		marginBottom: 6,
	},
	requiredAsterisk: {
		color: colors.danger,
	},
	sectionLabel: {
		...type.rowTitleSemibold,
		color: colors.text,
		marginTop: space.lg,
		marginBottom: space.sm,
	},
	deviceCard: {
		padding: space.md,
		borderWidth: 1,
		borderColor: colors.raisedBorder,
		backgroundColor: colors.raised,
		borderRadius: radius.card,
		marginBottom: space.md,
	},
	deviceName: {
		...type.rowTitleSemibold,
		color: colors.text,
		marginBottom: space.sm,
	},
	bayCard: {
		padding: space.md,
		borderWidth: 1,
		borderColor: colors.raisedBorder,
		backgroundColor: colors.raised,
		borderRadius: radius.card,
		marginBottom: space.md,
	},
	inlineAction: {
		alignItems: 'flex-start',
	},
	addAction: {
		alignItems: 'flex-start',
		marginBottom: space.md,
	},
	helperText: {
		...type.secondary,
		color: colors.textSecondary,
		marginBottom: space.md,
	},
	selectorButton: {
		width: 260,
	},
	ticketField: {
		marginBottom: space.lg,
	},
	ticketLabel: {
		...type.bodySmallSemibold,
		color: colors.text,
		marginBottom: 6,
	},
	ticketButton: {
		alignSelf: 'flex-start',
		marginTop: space.xs,
	},
});
